import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { scrollRef } from '../../state/scrollState/scrollSignals'
import { es } from '../../state/useEphemeralStore'

export const ScrollToTop = () => {
    const { pathname } = useLocation()

    useEffect(() => {
        const interval = setInterval(() => {
            es().setScrollTop(pathname, scrollRef.value?.current?.scrollTop)
        }, 500)
        scrollRef.value?.current?.scrollTo({
            top: es().pageStates[pathname]?.scrollTop ?? 0,
            left: 0,
            behavior: 'instant',
        })
        return () => {
            clearInterval(interval)
        }
    }, [pathname])

    return null
}
